import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

const useStyles = makeStyles((theme) => ({
  button: {
    '&:hover': {
      color: ({ color }) =>
        color === 'inherit' ? 'inherit' : (theme.palette[color] || {}).main,
    },
    '&:visited': {
      color: ({ color }) =>
        color === 'inherit'
          ? 'inherit'
          : (theme.palette[color] || {}).contrastText,
    },
  },
}));
export const LinkButton = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles(props);
  return (
    <Button
      component={Link}
      className={classnames(className, classes.button)}
      {...rest}
    />
  );
};

export const AButton = (props) => {
  const { className, ...rest } = props;
  const classes = useStyles(props);
  return (
    <Button
      component="a"
      className={classnames(className, classes.button)}
      {...rest}
    />
  );
};
